import { authService } from './authService';

const API_BASE_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3000';

/**
 * Bank Account Service - API calls for managing company bank accounts
 */
export const bankAccountService = {
    /**
     * Get all bank accounts
     */
    async getAll() {
        try {
            const response = await fetch(`${API_BASE_URL}/bank-accounts`, {
                method: 'GET',
                headers: authService.getAuthHeaders()
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to get bank accounts');
            return data;
        } catch (error) {
            console.error('Error getting bank accounts:', error);
            throw error;
        }
    },

    /**
     * Get bank accounts for select dropdown
     */
    async getSelectOptions() {
        try {
            const response = await fetch(`${API_BASE_URL}/bank-accounts/select`, {
                method: 'GET',
                headers: authService.getAuthHeaders()
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to get bank account options');
            return data;
        } catch (error) {
            console.error('Error getting bank account options:', error);
            throw error;
        }
    },

    /**
     * Get default bank account
     */
    async getDefault() {
        try {
            const response = await fetch(`${API_BASE_URL}/bank-accounts/default`, {
                method: 'GET',
                headers: authService.getAuthHeaders()
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to get default bank account');
            return data;
        } catch (error) {
            console.error('Error getting default bank account:', error);
            throw error;
        }
    },

    /**
     * Get single bank account by ID
     */
    async getById(accountId) {
        try {
            const response = await fetch(`${API_BASE_URL}/bank-accounts/${accountId}`, {
                method: 'GET',
                headers: authService.getAuthHeaders()
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to get bank account');
            return data;
        } catch (error) {
            console.error('Error getting bank account:', error);
            throw error;
        }
    },

    /**
     * Create new bank account
     */
    async create(accountData) {
        try {
            const response = await fetch(`${API_BASE_URL}/bank-accounts`, {
                method: 'POST',
                headers: {
                    ...authService.getAuthHeaders(),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(accountData)
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to create bank account');
            return data;
        } catch (error) {
            console.error('Error creating bank account:', error);
            throw error;
        }
    },

    /**
     * Update bank account
     */
    async update(accountId, accountData) {
        try {
            const response = await fetch(`${API_BASE_URL}/bank-accounts/${accountId}`, {
                method: 'PUT',
                headers: {
                    ...authService.getAuthHeaders(),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(accountData)
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to update bank account');
            return data;
        } catch (error) {
            console.error('Error updating bank account:', error);
            throw error;
        }
    },

    /**
     * Delete (deactivate) bank account
     */
    async delete(accountId) {
        try {
            const response = await fetch(`${API_BASE_URL}/bank-accounts/${accountId}`, {
                method: 'DELETE',
                headers: authService.getAuthHeaders()
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to delete bank account');
            return data;
        } catch (error) {
            console.error('Error deleting bank account:', error);
            throw error;
        }
    }
};
